import React from 'react';
import moment from 'moment';

const ShowContentCreated = ({projects, dailyProject, activeView}) => {

    if(projects === 'undefinded') return null
    return (
        <div>
            {projects?.map((project, index)=>{
                if(activeView === 'Content'){
                    var divCol = "bg-blue-50 rounded-lg"
                }else{
                    divCol = "bg-red-100 rounded-lg" 
                }

                if(project.ProspectContent === dailyProject.ContentCopied){
                    divCol = "bg-green-100 rounded-lg"
                }
                
                return(
                    <div
                    key={index}
                    className= {divCol}      ///"bg-gray-50 rounded-lg"
                    style={{marginBottom: '10px', whiteSpace: 'pre-line'}}
                    >
                        <div className="px-4 py-5 sm:p-6">
                            <p 
                            style={{
                                fontWeight: 700,
                                fontSize: 15,
                                marginBottom: '5px'
                            }}
                            >
                                {project?.ProspectName}
                                <span className="text-sm text-gray-500 float-right mt-2">
                                {project?.ProspectInterestUsed?.activity_status?.length > 0 ?
                                <span>
                                Interest: Recent Activity
                                </span>
                                :
                                <span>
                                Interest: 
                                {project?.ProspectInterestUsed ? 
                                project?.ProspectInterestUsed 
                                : 
                                project?.InterestUsed
                                }
                                </span> 
                                } 
                                </span>
                            </p>
                            <p className="text-sm text-gray-500  mt-2">
                                {project?.ProspectContent}  
                            </p>
                            <p className="text-sm text-gray-500 truncate mt-2">
                                {project?.CreatedAt ? 
                                    <span>{moment(project?.CreatedAt?.toDate()).calendar()}</span>
                                :
                                    <span>{moment(project?.createdAt?.toDate()).calendar()}</span>
                                }
                            </p>
                        </div>
                    </div>
                )
            })}  
        </div>
    )
}

export default ShowContentCreated
